import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export const exportToExcel = ({
	data = [],
	fileName = 'Export',
	sheetName = 'Sheet1',
	columns = [],
}) => {
	if (!Array.isArray(data) || !data.length) return

	const formattedData = data.map((item, index) => {
		const row = {}

		columns.forEach(col => {
			if (col.key === 'index') {
				row[col.label] = index + 1
			} else if (typeof col.render === 'function') {
				row[col.label] = col.render(item)
			} else {
				row[col.label] = item[col.key] ?? ''
			}
		})

		return row
	})

	const worksheet = XLSX.utils.json_to_sheet(formattedData)
	const workbook = XLSX.utils.book_new()
	XLSX.utils.book_append_sheet(workbook, worksheet, sheetName)

	const excelBuffer = XLSX.write(workbook, {
		bookType: 'xlsx',
		type: 'array',
	})

	const blob = new Blob([excelBuffer], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	})

	saveAs(blob, `${fileName}.xlsx`)
}
